module.exports = __webpack_public_path__ + "images/operator-framework-logo-lite.svg";